// extracted by mini-css-extract-plugin
module.exports = {"container":"SplashScreen_container__t-9v4","logo":"SplashScreen_logo__3Beqk"};